// extracted by mini-css-extract-plugin
export default {"root":"Country_root__zGsoG","status-block":"Country_status-block__gpA1V","status-title":"Country_status-title__Zy0Lj","country":"Country_country__nTwbh"};